import { render } from "./CompanyDetail.vue?vue&type=template&id=4b567acb"
import script from "./CompanyDetail.vue?vue&type=script&lang=js"
export * from "./CompanyDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__